import IconButton from '@/components/UI/buttons/IconButton'
import { useRouteBackToParam } from '@/features/navigation/hooks/can-go-back'
import BackArrowIcon from '@/features/ui/icons/components/BackArrowIcon'
import { router } from 'expo-router'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

const CompactMainHeaderBackButton: FC<{ onPress?: () => void }> = ({ onPress }) => {
    const backTo = useRouteBackToParam()
    const { t } = useTranslation('app')

    const handlePress = () => {
        if (backTo) return router.dismissTo(backTo)

        router.back()
    }

    return (
        <IconButton
            accessibilityRole="button"
            accessibilityLabel={t('actions.back')}
            size={40}
            Icon={BackArrowIcon}
            onPress={onPress ?? handlePress}
            style={{ paddingLeft: 4, marginLeft: 12 }}
        />
    )
}

export default CompactMainHeaderBackButton
